import React, { useState } from "react";
import { HiMiniPlus, HiOutlineTrash } from "react-icons/hi2";
import { IoIosLink } from "react-icons/io";

const AddAttachmentsInput = ({ attachments, setAttachments }) => {
  const [option, setOption] = useState("");

  const handleAddOption = () => {
  if (option.trim()) {
    setAttachments([...attachments,option.trim()]); // <-- juste une string
    setOption('');
  }
};


  const handleDeleteOption = (index) => {
    const updatedArr = attachments.filter((_, idx) => idx !== index);
    setAttachments(updatedArr);
  };

  return (
    <div>
      {(attachments || []).map((item, index) => (
        <div
          key={index}
          className="flex justify-between bg-gray-50 border border-gray-100 px-3 py-2 rounded-md mb-3 mt-2"
        >
          <div className="flex-1 flex items-center gap-3 border border-gray-100">
            <IoIosLink className="text-gray-400" />
            <p className="text-xs text-black">
              {item}
            </p>
          </div>
          <button
            type="button"
            onClick={() => handleDeleteOption(index)}
            className="cursor-pointer"
          >
            <HiOutlineTrash className="text-lg text-red-500" />
          </button>
        </div>
      ))}

      <div className="flex items-center gap-5 mt-4">
        <div className="flex-1 flex items-center gap-3 border border-gray-100 px-3 py-2 rounded-md">
          <IoIosLink className="text-gray-400" />
          <input
            type="text"
            placeholder="ajouter le lien d'un fichier"
            value={option}
            onChange={(e) => setOption(e.target.value)}
            className="w-full text-[13px] text-black outline-none bg-white py-2 px-2"
          />
          <button
            type="button"
            onClick={handleAddOption}
            className="card-btn text-nowrap"
          >
            <HiMiniPlus className="text-lg" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddAttachmentsInput;
